export const formatForensicValue = (name, value, unit) => {
    if (value == null || Number.isNaN(Number(value))) return '—';
    const n = Number(value);
    if (name === 'sloanAccrualRatio') return `${(n * 100).toFixed(1)}%`;
    if (unit === 'days') return n.toFixed(0);
    if (unit === '%') return n.toFixed(1);
    if (unit === 'score' || name === 'beneishMScore' || name === 'altmanZScore') {
        return n.toFixed(2);
    }
    if (name === 'montierCScore' || name === 'piotroskiFScore') {
        return String(Math.round(n));
    }
    return n.toFixed(2);
};

export const zoneClass = (zone) => {
    if (zone === 'green') return 'forensic-zone--green';
    if (zone === 'yellow') return 'forensic-zone--yellow';
    if (zone === 'red') return 'forensic-zone--red';
    return 'forensic-zone--neutral';
};

const HEADLINE_ZONES = new Set([
    'beneishMScore',
    'montierCScore',
    'sloanAccrualRatio',
    'piotroskiFScore',
    'altmanZScore',
]);

/** Discrete legend buckets — no interpolation. Matches Disclosed Cutoffs. */
export const heatmapZone = (name, value) => {
    if (!HEADLINE_ZONES.has(name) || value == null || Number.isNaN(Number(value))) {
        return null;
    }
    const n = Number(value);
    if (name === 'beneishMScore') {
        if (n < -2.22) return 'green';
        if (n <= -1.78) return 'yellow';
        return 'red';
    }
    if (name === 'montierCScore') {
        if (n <= 1) return 'green';
        if (n <= 3) return 'yellow';
        return 'red';
    }
    if (name === 'sloanAccrualRatio') {
        if (n <= 0.06) return 'green';
        if (n <= 0.10) return 'yellow';
        return 'red';
    }
    if (name === 'altmanZScore') {
        if (n > 2.60) return 'green';
        if (n >= 1.10) return 'yellow';
        return 'red';
    }
    if (name === 'piotroskiFScore') {
        if (n >= 7) return 'green';
        if (n >= 3) return 'yellow';
        return 'red';
    }
    return null;
};

export const parseForensicPayload = (payload) => {
    if (!payload) return { report: null, ratios: [] };
    if (Array.isArray(payload)) {
        const tab = payload.find((row) => row?.tab === 'forensic');
        return { report: null, ratios: tab?.ratios || [] };
    }
    if (payload.report) {
        const groups = payload.ratios;
        if (Array.isArray(groups) && groups[0]?.tab) {
            return { report: payload.report, ratios: groups[0].ratios || [] };
        }
        if (Array.isArray(groups) && groups[0]?.name) {
            return { report: payload.report, ratios: groups };
        }
        return { report: payload.report, ratios: [] };
    }
    if (Array.isArray(payload.ratios)) {
        return { report: null, ratios: payload.ratios };
    }
    return { report: null, ratios: [] };
};
